import { render, staticRenderFns } from "./AgentPhoneForm.vue?vue&type=template&id=38d43060&"
import script from "./AgentPhoneForm.vue?vue&type=script&lang=js&"
export * from "./AgentPhoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports